var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"23","cy":"23","r":"23","fill":"#ACB5BD","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 23a1.5 1.5 0 0 1 1.5-1.5h21a1.5 1.5 0 0 1 0 3h-21A1.5 1.5 0 0 1 11 23z","fill":"#fff","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.94 11.44a1.5 1.5 0 0 1 2.12 0l10.5 10.5a1.5 1.5 0 0 1 0 2.12l-10.5 10.5a1.5 1.5 0 0 1-2.12-2.12L31.378 23l-9.44-9.44a1.5 1.5 0 0 1 0-2.12z","fill":"#fff","key":2})]);
}

Arrow.defaultProps = {"viewBox":"0 0 46 46","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
